/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramFavouritesUserControllerToggleMutationRequest,
  TelegramFavouritesUserControllerToggleMutationResponse,
  TelegramFavouritesUserControllerToggle401,
} from '../types/TelegramFavouritesUserControllerToggle.ts';

function getTelegramFavouritesUserToggleUrl() {
  const res = { method: 'POST', url: `/api/user/telegram/favourites/toggle` as const };
  return res;
}

/**
 * {@link /api/user/telegram/favourites/toggle}
 */
export async function telegramFavouritesUserToggle(
  data: TelegramFavouritesUserControllerToggleMutationRequest,
  config: Partial<RequestConfig<TelegramFavouritesUserControllerToggleMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramFavouritesUserControllerToggleMutationResponse,
    ResponseErrorConfig<TelegramFavouritesUserControllerToggle401>,
    TelegramFavouritesUserControllerToggleMutationRequest
  >({ method: 'POST', url: getTelegramFavouritesUserToggleUrl().url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
